import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import CheckOrganizationSyncPermissions from '../../../../components/check-organization-sync-permissions';

class OrganizationSyncPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organization: null,
      showModal: false,
    };
    this.close = this.close.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const currentId = this.props.organization ? this.props.organization._id : null;
    const nextId = nextProps.organization ? nextProps.organization._id : null;
    if (nextId !== currentId && nextId) {
      this.setState({
        showModal: true,
        organization: nextProps.organization,
      });
    } else if (!nextId) {
      this.setState({ showModal: false });
    }
  }

  close() {
    this.props.onClose();
  }

  render() {
    const {
      organization,
    } = this.state;
    if (!organization) {
      return null;
    }

    return (
      <Modal show={this.state.showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{organization.display_name} Sync Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.props.organization !== null && <CheckOrganizationSyncPermissions forceShowList organization={this.props.organization} />}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="link" onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

OrganizationSyncPermissions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }),
  onClose: PropTypes.func,
};
OrganizationSyncPermissions.defaultProps = {
  organization: null,
  onClose: () => {},
};
function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(OrganizationSyncPermissions);
